export default class ScrollToLink {
    init() {
        let self = this;

        // Au chargement, on verifie s'il y a une ancre dans l'url de la page. S'il y en a une, on scroll vers cette ancre
        let curentURL = window.location.href;
        if (curentURL.search('#') != -1) {
            let link = curentURL.split('#')[1].split('/')[0];

            if (link) {
                self.scrollTo('#' + link);
            }
        }

        $('.scroll-to').on('click', (e) => {
            e.preventDefault();

            let link = e.target.getAttribute('href');
            self.scrollTo(link);
        });
    }

    scrollTo(link) {
        const $target = $(link);
        if (!$target.length) return;

        const header = document.getElementById('sticky-header');
        const headerHeight = header ? header.offsetHeight + 50 : 0;

        $('html, body').animate(
            { scrollTop: $target.offset().top - headerHeight },
            400
        );
    }

}